module.exports = __webpack_public_path__ + "img/service-01.c2182364.svg";